var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2621_55084",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2621_55084)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 16.918L20.3542 21.2717C20.4788 21.3966 20.6317 21.4547 20.8128 21.446C20.9942 21.4376 21.1472 21.3709 21.2718 21.246C21.3967 21.1213 21.4592 20.9685 21.4592 20.7873C21.4592 20.606 21.3967 20.453 21.2718 20.3283L16.9182 16L21.2718 11.646C21.3967 11.5213 21.4592 11.3685 21.4592 11.1873C21.4592 11.006 21.3967 10.853 21.2718 10.7283C21.1472 10.6035 20.9942 10.541 20.8128 10.541C20.6317 10.541 20.4788 10.6035 20.3542 10.7283L16.0002 15.082L11.6462 10.7283C11.5215 10.6035 11.3728 10.541 11.2002 10.541C11.0275 10.541 10.8788 10.6035 10.7542 10.7283C10.6293 10.853 10.5668 11.006 10.5668 11.1873C10.5668 11.3685 10.6293 11.5213 10.7542 11.646L15.0822 16L10.7285 20.354C10.6036 20.4787 10.5455 20.6273 10.5542 20.8C10.5626 20.9727 10.6293 21.1213 10.7542 21.246C10.8788 21.3709 11.0317 21.4333 11.2128 21.4333C11.3942 21.4333 11.5472 21.3709 11.6718 21.246L16.0002 16.918ZM7.4875 26.6667C6.87372 26.6667 6.36127 26.4611 5.95016 26.05C5.53905 25.6389 5.3335 25.1265 5.3335 24.5127V7.48734C5.3335 6.87357 5.53905 6.36112 5.95016 5.95001C6.36127 5.5389 6.87372 5.33334 7.4875 5.33334H24.5128C25.1266 5.33334 25.6391 5.5389 26.0502 5.95001C26.4613 6.36112 26.6668 6.87357 26.6668 7.48734V24.5127C26.6668 25.1265 26.4613 25.6389 26.0502 26.05C25.6391 26.4611 25.1266 26.6667 24.5128 26.6667H7.4875ZM7.4875 25.3333H24.5128C24.7182 25.3333 24.9063 25.2479 25.0772 25.077C25.2481 24.9061 25.3335 24.718 25.3335 24.5127V7.48734C25.3335 7.28201 25.2481 7.0939 25.0772 6.92301C24.9063 6.75212 24.7182 6.66668 24.5128 6.66668H7.4875C7.28216 6.66668 7.09405 6.75212 6.92316 6.92301C6.75227 7.0939 6.66683 7.28201 6.66683 7.48734V24.5127C6.66683 24.718 6.75227 24.9061 6.92316 25.077C7.09405 25.2479 7.28216 25.3333 7.4875 25.3333Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseLarge);
export default __webpack_public_path__ + "static/media/close_large.4133e6a92fbddd697c17e2fc6a90245a.svg";
export { ForwardRef as ReactComponent };